import { Heart } from "lucide-react";
import { useWishlist } from "../../context/WishlistContext";

/**
 * Reusable wishlist heart toggle.
 * variant: "card" (small overlay) | "icon" (medium standalone) | "button" (with label)
 */
export default function WishlistHeart({ productId, variant = "icon", className = "" }) {
  const { has, toggle, loading } = useWishlist();
  const active = has(productId);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!loading) toggle(productId);
  };

  if (variant === "card") {
    return (
      <button onClick={onClick} data-testid={`wishlist-heart-${productId}`}
              aria-label={active ? "Remove from wishlist" : "Add to wishlist"}
              className={`absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white/90 backdrop-blur flex items-center justify-center shadow hover:scale-110 transition-transform ${className}`}>
        <Heart className={`w-4 h-4 ${active ? "fill-[#993322] text-[#993322]" : "text-stone-500"}`} />
      </button>
    );
  }
  if (variant === "button") {
    return (
      <button onClick={onClick} data-testid={`wishlist-btn-${productId}`}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border-2 transition-colors ${
                active ? "bg-[#993322]/10 border-[#993322] text-[#993322]" : "border-stone-200 text-stone-600 hover:border-[#993322]/40"
              } ${className}`}>
        <Heart className={`w-4 h-4 ${active ? "fill-[#993322]" : ""}`}/>
        <span className="text-sm font-medium">{active ? "Saved" : "Save"}</span>
      </button>
    );
  }
  return (
    <button onClick={onClick} data-testid={`wishlist-heart-${productId}`}
            aria-label={active ? "Remove from wishlist" : "Add to wishlist"}
            className={`w-12 h-12 rounded-full border-2 border-stone-200 bg-white flex items-center justify-center hover:border-[#993322]/40 transition-colors ${className}`}>
      <Heart className={`w-5 h-5 ${active ? "fill-[#993322] text-[#993322]" : "text-stone-500"}`}/>
    </button>
  );
}
